// extracted by mini-css-extract-plugin
export default {"fitContent":"Modal_fitContent__2bW51","wrapper":"Modal_wrapper__eo+zm"};